module.exports = __webpack_public_path__ + "img/signature.fc714f04.svg";